import { Injectable } from '@angular/core';
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { GlobalComponent } from 'src/app/global-component';

@Injectable({
  providedIn: 'root'
})

//For options
//https://codeseven.github.io/toastr/demo.html
export class ToasterNotificationService {

  constructor(private toastr: ToastrService) { }
   
  showSuccess(message:string, title:string, options:Partial<IndividualConfig> | undefined = undefined) {
      if(options) {
        this.toastr.success(message, title, options);
      }
      else {
        this.toastr.success(message, title, GlobalComponent.defaultToasterOptions);
      }
  }
   
  showError(message:string, title:string, options:Partial<IndividualConfig> | undefined = undefined) {
    if(options) 
    {
      this.toastr.error(message, title, options);
    }
    else 
    {
      this.toastr.error(message, title, GlobalComponent.defaultToasterOptions);
    }
  }
   
  showInfo(message:string, title:string, options:Partial<IndividualConfig> | undefined = undefined) {
    if(options) 
    {
      this.toastr.info(message, title, options); 
    }
    else 
    {
      this.toastr.info(message, title, GlobalComponent.defaultToasterOptions);
    }
  }
   
  showWarning(message:string, title:string,  options:Partial<IndividualConfig> | undefined = undefined) {
    if(options) 
    {
      this.toastr.warning(message, title, options);
    }
    else 
    {
      this.toastr.warning(message, title, GlobalComponent.defaultToasterOptions);
    }
  }
}
